/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_Token_MissingInputs */

const cs_auth_reset_token_missing = /** @type {(inputs: Auth_Reset_Token_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz pro obnovení hesla chybí nebo je neúplný. Požádejte o nový.`)
};

const en_auth_reset_token_missing = /** @type {(inputs: Auth_Reset_Token_MissingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This reset link is missing or incomplete. Request a new one.`)
};

/**
* | output |
* | --- |
* | "This reset link is missing or incomplete. Request a new one." |
*
* @param {Auth_Reset_Token_MissingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_token_missing = /** @type {((inputs?: Auth_Reset_Token_MissingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_Token_MissingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_token_missing(inputs)
	return cs_auth_reset_token_missing(inputs)
});